import { AbstractDataProviderV2 } from 'components/system';
import { RsCustomerContactType } from 'common/customers/services/types';
import { RsCustomerContactTypeInfo } from 'common/customers/services/types/RsCustomerContactTypeInfo';
import { CustomerContactTypeAdd } from 'common/customers/services/types/CustomerContactTypeAdd';
import { CustomerContactTypeUpdate } from 'common/customers/services/types/CustomerContactTypeUpdate';

export class CustomerContactTypeDataProvider extends AbstractDataProviderV2<
    RsCustomerContactType,
    RsCustomerContactTypeInfo,
    CustomerContactTypeAdd,
    CustomerContactTypeUpdate
> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/dict/contact-types');
    }

    public patch(): Promise<any> {
        return Promise.reject('method is not supported');
    }
}
